module.exports = __webpack_public_path__ + "img/phone-car-with-map-screen@2x.d5db4f03.png";